import { ref } from '../config/firebase';
import moment from 'moment/moment';

import { createCompany as createCompanyRequest, updateCompany as updateCompanyRequest } from './cloud-functions';

export async function createCompany(company) {
    const currentDate = moment().valueOf();
    return createCompanyRequest({
        name: company.name.trim(),
        platform: company.platform.split(','),
        phone: company.phoneNumber || null,
        size: company.companySize,
        industry: company.industry,
        otherIndustry: company.otherIndustry || '',
        vertical: company.vertical,
        otherVertical: company.otherVertical || '',
        country: company.country,
        address: company.address,
        city: company.city,
        state: company.state,
        postalCode: company.postalCode,
        createdAt: currentDate,
        updatedAt: currentDate,
    });
}

export function getCompany(companyId) {
    return ref.child(`COMPANIES/${companyId}`).once('value')
        .then((companySnapshot) => {
            let company = {};

            if (companySnapshot.exists()) {
                company = Object.assign(companySnapshot.val(), { firebaseId: companyId });
            }

            return company;
        });
}

export function updateCompany(companyId, params) {
    return ref.child(`COMPANIES/${companyId}`).update(params);
}

export async function changeCompany(company) {
    const currentDate = moment().valueOf();
    return updateCompanyRequest({
        name: company.name.trim(),
        platform: company.platform,
        phone: company.phoneNumber || null,
        size: company.companySize,
        industry: company.industry,
        otherIndustry: company.otherIndustry || '',
        vertical: company.vertical,
        otherVertical: company.otherVertical || '',
        country: company.country,
        address: company.address,
        city: company.city,
        state: company.state,
        postalCode: company.postalCode,
        updatedAt: currentDate,
        firebaseId: company.firebaseId,
    });
}

export function getPendingFacilitiesAdmin() {
    return ref.child(`PENDING_FACILITIES`).once('value')
        .then((companiesSnapshot) => {
            return companiesSnapshot.val();
        });
}

export function getPendingFacilities(companyId) {
    return ref.child(`PENDING_FACILITIES/${companyId}`).once('value')
        .then((companySnapshot) => {
            return companySnapshot.val();
        });
}

export function updatePendingFacilities(companyId, params) {
    if (!params) {
        return ref.child(`PENDING_FACILITIES/${companyId}`).remove();
    } else {
        return ref.child(`PENDING_FACILITIES/${companyId}`).update(params);
    }
}



// WEBPACK FOOTER //
// ./src/firebase/company.js